import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { FormError } from '../../FormError.jsx';
import CustomRadio from '../../CustomRadio.jsx';
import FieldGroup from '../../FieldGroup.jsx';
import CIExampleCSVDownloadButton from './CIExampleCSVDownloadButton.jsx';
import { ChangeImpactsLink } from '../../links/index.jsx';

const replaceOptions = [
  { label: 'Add new Change Impacts to existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

const ChangeImpactDataImportForm = (props) => {
  const {
    projectId,
    values,
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    replaceMethod,
    setReplaceMethod,
    formRef,
  } = props;

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <p className="text-muted m-b-24">
        Quickly import your data from other platforms by uploading a CSV file.{' '}
        <br />
        To ensure your data is formatted correctly, download our CSV template.
      </p>

      <div className="component-lg component-border-bottom component-border-top component-border-left component-border-right m-b-48">
        <h2 className="text-muted m-b-28">Change Impacts</h2>
        <Row>
          <Col xs={12}>
            <div className="m-b-16">
              <CustomRadio
                name="replaceMethod"
                checkedValue={replaceMethod}
                options={replaceOptions}
                action={setReplaceMethod}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="m-b-18">
              <CIExampleCSVDownloadButton />
            </div>
          </Col>
          <Col xs={12}>
            <Field
              id="changeImpactsFormCsvFile"
              name="csv_file"
              type="file"
              component={FieldGroup}
              accept=".csv"
              customClass="m-b-0"
            />
          </Col>
        </Row>
      </div>
      <Row className="m-b-48">
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>
        <Col xs={12}>
          <div className="flex">
            <div>
              <ChangeImpactsLink projectId={projectId}>
                <Button bsStyle="default">Cancel</Button>
              </ChangeImpactsLink>
              <Button
                className="m-l-12"
                bsStyle="primary"
                type="submit"
                disabled={!values.csv_file || submitting}
              >
                {submitting ? 'Importing...' : 'Import'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default ChangeImpactDataImportForm;
